module.exports = __webpack_public_path__ + "assets/a-16-yiyuan.dbd13a35.svg";